import(/* webpackMode: "eager" */ "/workspace/app/login/page.js");
